import { createFileRoute } from '@tanstack/react-router'
import { DokumenList } from '../../../../components/DokumenList'

export const Route = createFileRoute('/desa/$slug/dashboard/dokumen')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <DokumenList desaId={desaId} />
  },
})
